import { render } from "./Presentations.vue?vue&type=template&id=b7fe00d0&scoped=true"
import script from "./Presentations.vue?vue&type=script&lang=ts"
export * from "./Presentations.vue?vue&type=script&lang=ts"

import "./Presentations.vue?vue&type=style&index=0&id=b7fe00d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7fe00d0"

export default script